export const environment = {
  production: true,
  environment: "qa",
  webApiUrl: "https://enetcloud-uk6-sjib-bms-cdn-api-qa.azurewebsites.net",
  blobStorageUrl: "https://ecomstorageproduction.blob.core.windows.net",
  blobStorageContainer: "sjib-cdn-test",
  assessBlobStorageContainer: "sjib-bms-enetassess-qa",
  eproctUrl: "https://enetcloud-uk6-sjib-bms-proctoring-qa.azurewebsites.net",
  bmsUrl: "http://enetcloud-uk6-sjib-bms-qa.azurewebsites.net",
  kioskMode: true,
  kioskDownload: "https://enetcloud-uk6-sjib-bms-qa.azurewebsites.net/enetsecure/install/enetsecure_qa_v10_13112023.zip",
  dataSyncItems: [
    {
        "title": "Question Response Media",
        "object": "questionResponseMedia",
        "url": "/assets/data/QuestionResponseMedia.json"
    },
    {
        "title": "Question Responses",
        "object": "questionResponses",
        "url": "/assets/data/QuestionResponses.json"
    },
    {
        "title": "Questions",
        "object": "questions",
        "url": "/assets/data/Questions.json"
    },
    {
        "title": "Schedule Candidates",
        "object": "scheduleCandidates",
        "url": "/assets/data/ScheduleCandidates.json"
    },
    {
        "title": "Schedules",
        "object": "schedules",
        "url": "/assets/data/Schedules.json"
    },
    {
        "title": "Session Questions",
        "object": "sessionQuestions",
        "url": "/assets/data/SessionQuestions.json"
    },
    {
        "title": "Sessions",
        "object": "sessions",
        "url": "/assets/data/Sessions.json"
    },
    {
        "title": "Session Results",
        "object": "sessionResults",
        "url": "/assets/data/SessionResults.json"
    },
    {
        "title": "Mocks",
        "object": "mocks",
        "url": "/assets/data/Mocks.json"
    }
  ],
  previewSyncItems : [
      {
          "title": "Question Responses",
          "object": "questionResponses",
          "url": "/assets/data/QuestionResponses.json"
      },
      {
          "title": "Questions",
          "object": "questions",
          "url": "/assets/data/Questions.json"
      },
      {
          "title": "Question Response Media",
          "object": "questionResponseMedia",
          "url": "/assets/data/QuestionResponseMedia.json"
      }
  ]
};